<script lang="ts">
	//Stores
	import { devices, pin_unlocked_devices } from 'src/stores';
	import { os } from 'src/stores';
	//Services
	import { zwaveMultilevelSwitchSet } from '../../../services/xz_http_reqs';
	import { hapticFeedback } from '../../../services/native_container_requests_ios';
	import { format } from 'svelte-i18n';
	//Helpers
	import { get_z_wave_channel_structure_from_category } from '../../../helpers/interface_helpers';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Design system components
	import { SliderV2, toast } from '@Shelly/shelly-design-system';
	//Components
	import PinUnlock from '../../PinUnlock.svelte';

	export let device, status;

	let value = 0;
	let valueCache;
	let targetValue;

	let showModal = false;

	let callbackValue;

	let isLoading = false;

	$: component = get_z_wave_channel_structure_from_category(device);
	$: coverStatus = status?.[component];
	$: coverPosition = coverStatus?.current_pos ?? coverStatus?.currentValue ?? coverStatus?.pos ?? 0;

	$: pinLocked =
		typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

	$: isRolling = targetValue !== undefined && coverPosition !== targetValue;

	$: rollingDirection =
		coverStatus?.state === 'opening' || coverStatus?.state === 'closing'
			? coverStatus.state
			: valueCache !== undefined
				? valueCache > value
					? 'opening'
					: 'closing'
				: 'stopped';

	$: if (!isRolling) {
		value = coverPosition || 0;
	}

	$: if (coverPosition === targetValue) {
		targetValue = undefined;
		valueCache = undefined;
	}

	const changePosition = async (selectedPosition) => {
		if (!pinLocked) {
			valueCache = value;
			value = selectedPosition;
			targetValue = value;
			isLoading = true;

			if ($os === 'IOS') {
				hapticFeedback('buttonPressed');
			}

			const res = await zwaveMultilevelSwitchSet(device, value);

			if (!res.isok) {
				value = valueCache;
				toast.open({
					type: 'danger',
					title: $format('device_control_failed_long'),
				});
			}
			isLoading = false;
		} else {
			callbackValue = selectedPosition;
			showModal = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
		changePosition(callbackValue);
		callbackValue = undefined;
	};

	const handleClose = () => {
		value = valueCache;
	};

	const a11yProps = {
		sliderAriaLabel: $format('label_set_position', { default: 'Set position' }),
		ariaLabel: $format('label_set_position', { default: 'Set position' }),
		ariaLabelValue: $format('label_set_position', { default: 'Set position' }),
	};
</script>

<SliderV2
	id="slider-kitzf5n"
	class="flex-full-height min-height-0 justify-content-center"
	{a11yProps}
	title={isRolling
		? capFirstChar($format(`state_${rollingDirection}`, { default: rollingDirection }))
		: capFirstChar($format('state_opened', { default: 'opened' }))}
	{value}
	on:value_change={(e) => {
		changePosition(e.detail.value);
	}}
	on:move={() => {
		if ($os === 'IOS') {
			hapticFeedback('selection');
		}
	}}
	{isLoading}
/>

{#if showModal}
	<PinUnlock
		bind:showModal
		on:unlock={handlePin}
		on:close={handleClose}
		on:cancel={() => (showModal = false)}
	/>
{/if}
